import { render, staticRenderFns } from "./SummaryBreakdown.vue?vue&type=template&id=4604384c&"
import script from "./SummaryBreakdown.vue?vue&type=script&lang=js&"
export * from "./SummaryBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4604384c')) {
      api.createRecord('4604384c', component.options)
    } else {
      api.reload('4604384c', component.options)
    }
    module.hot.accept("./SummaryBreakdown.vue?vue&type=template&id=4604384c&", function () {
      api.rerender('4604384c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/Global/SummaryBreakdown.vue"
export default component.exports